import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";


import { getCompanies } from "../../../../../MyApi/hr/companies";

import LoadingSpinner from "../../../../UI/spinner";
import PagnationComponent from "../../../../UI/pagnationComponent";
import SingleCompany from "../singleCompany";
import NoData from "../../../../UI/nodata";
import ErrorMessage from "../../../../UI/error";

import classes from "../../../../../assets/css/globalDataTable.module.css";




const CompaniesDataTable = () => {
const[filterText ,setFilterText] = useState("")
const [currenetPage ,setCurrentPage] = useState(1)
const {t,i18n}=useTranslation()
const lang =i18n.language
const {data , isLoading ,refetch ,error} = useQuery(["getCompanies" ,currenetPage ,lang] ,()=>getCompanies(currenetPage ,lang))



useEffect(()=>{
  refetch()
},[refetch ,filterText])

const handleSearchChange = (e)=>{
setFilterText(e.target.value)
}

const totalItems= data?.total
const companies = data?.data ||[]
const responeMessage= data?.message

const filterdData = companies.filter((comapny)=>comapny.name.toString().toLowerCase().includes(filterText))

if(isLoading){
    return <LoadingSpinner/>
}
if(companies.length === 0){
  return<NoData responeMessage={responeMessage}/>
}
if(error){  
  return <ErrorMessage error={error}/>
}



if(!data){
    return <div>no data available</div>
}

  return (
    <div className="container-fluid"> 
      <div className="card">
        <div className="table-responsive-sm">
        <table className="table-responsive-sm table table-striped table-hover">
            <thead className={classes.tableHeader}>    
            <th>#</th> 
            <th>{t("Name")}</th>  
            <th> {t("Country")}</th>
            <th> {t("Field")}</th>
            <th>{t("Active")}</th>
            <th>{t("Actions")}</th>    
            </thead>
          <tbody>
          {filterdData.map((company)=> ( <SingleCompany key={company.id}  company={company}  classes={classes} refetch={refetch}/>))   }
          </tbody>
        </table> 
        </div>
        </div>
        <div className="d-flex justify-content-center">
           <PagnationComponent  currentPage={currenetPage} totalItems={totalItems} setCurrentPage={setCurrentPage}/>
        </div>   
    </div>
  );
};

export default CompaniesDataTable;
